// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getSystemList, SystemListApiParameter, SystemListModel } from "@tps/App/Services/SystemListService";

type HandlerType = ApiHandler<SystemListApiParameter, SystemListModel>;

export const DispatchBeginLoadShippingTerms: HandlerType = props => {
    props.dispatch({
        type: "xShippingTerms/BeginLoadShippingTerms" as any,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSystemList(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xShippingTerms/CompleteLoadShippingTerms",
            data: null,
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadShippingTerms: HandlerType = props => {
    props.dispatch({
        type: "xShippingTerms/CompleteLoadShippingTerms",
        data: props.apiResult,
    } as any);
};

export const chain = [
    DispatchBeginLoadShippingTerms,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadShippingTerms,
];

const loadShippingTerms = createHandlerChainRunner(chain, "LoadShippingTerms");
export default loadShippingTerms;
